<template>
  <div id="tabLclContainer" style="height:100%;display: flex;flex-direction: column;">
    <cargo-up-down-resize
      class="app-main-inner"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column',paddingTop:'5px'}"
      style="height: 100%"
    >
      <template slot="up">
        <div v-show="readonly && viewSource!=='salesDetail'" class="section">
          <div>
            <el-button no="1" type="primary" @click="pm.addSlaveHandler()">{{ $t('SeaExport.AddTickets') }}</el-button>
            <el-button no="2" type="danger" @click="pm.removeSlaveHandler()">{{ $t('SeaExport.RemoveTickets') }}</el-button>
          </div>
        </div>
        <div class="section" style="flex-grow:1">
          <cargo-ag-grid
            no="3"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="columnDefs"
            :row-data="lclSlaves"
            style="width:100%;height:100%"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div style="padding:5px 0">
          <div style="float:left">
            <el-button v-show="isEdit" no="4" type="info" plain style="color:green" @click="pm.addToContainerHandler()">↓</el-button>
            <el-button v-show="isEdit" no="5" type="info" plain style="color:red" @click="pm.removeToContainerHandler()">↑</el-button>
          </div>
          <div style="float:right">
            <el-form :inline="true" label-width="55px" label-position="left">
              <el-form-item :label="totalLabel.package" class="custom">
                <span>{{ slaveTotalDesc.slaveTotalQuantity }}</span>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalNumberOfPackages')" class="custom">
                <span>{{ slaveTotalDesc.slaveTotalWeight }}</span>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalCubage')" class="custom">
                <span>{{ slaveTotalDesc.slaveTotalCubage }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template slot="down">
        <cargo-left-right-resize
          :left-style="{display: 'flex', flexDirection: 'column',width:'20%'}"
          :right-style="{display: 'flex', flexDirection: 'column',width:'80%'}"
          style="height: 100%;min-height: 300px"
        >
          <template slot="left">
            <cargo-ag-grid
              no="6"
              :grid-options="left.gridOptions"
              :grid-params.sync="left.gridParams"
              :column-defs="containerColumnDefs"
              :row-data="containers"
              style="height:100%"
              @gridReady="params=>left.gridApi=params.api"
            />
          </template>
          <template slot="right">
            <div class="section" style="flex: 1;">
              <cargo-ag-grid
                no="7"
                :grid-options="right.gridOptions"
                :grid-params.sync="right.gridParams"
                :column-defs="usageColumnDefs"
                :row-data="selectedContainer.containerUsage"
                style="flex-grow:1"
                @gridReady="params=>right.gridApi=params.api"
              />
            </div>
            <div style="padding:5px 0">
              <div style="float:left">
                <span>{{ usagesTotalDesc.txtNum }}</span>
              </div>
              <div style="float:right">
                <el-form :inline="true" label-width="55px" label-position="left">
                  <el-form-item :label="totalLabel.package" class="custom">
                    <span>{{ usagesTotalDesc.usageTotalQuantity }}</span>
                  </el-form-item>
                  <el-form-item :label="totalLabel.weight" class="custom">
                    <span>{{ usagesTotalDesc.usageTotalWeight }}</span>
                  </el-form-item>
                  <el-form-item :label="totalLabel.cubage" class="custom">
                    <span>{{ usagesTotalDesc.usageTotalCubage }}</span>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-up-down-resize>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="job"
      @callback="rows=>{pm.slaveAddedHandler(rows)}"
    />
  </div>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { TabLclContainerBase } from './tabLclContainerBase'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ContainerNoHelper from '@/utils/containerNoHelper'
import * as NumberUtils from '@/utils/NumberUtils'
import { Job } from '@/class/model/booking/Job'
import { Container } from '@/class/model/booking/Container'
import { sortByMultiField } from '@/utils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import QueryLclDialog from '@/components/Cargo/Job/queryLclDialog'
import { ContainerNewUtil } from '@/class/cargo/model/utils/ContainerNewUtil'
import { roundHalfUp } from '@/utils/NumberUtils'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { syncContainersToExport } from '@/api/SeaImport/seaImportJob'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'

export default {
  name: 'TabLclContainer',
  components: { QueryLclDialog, cargoUpDownResize, cargoLeftRightResize },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    location: { // 日志【模块位置】,【数据更新日志】使用
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pm: new TabLclContainerBase(this),
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowSelection: false,
        suppressRowClickSelection: false,
        rowMultiSelectWithClick: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.onRowClicked
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: 'MBL',
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          field: 'dischargingPortCode',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PackageType'),
          field: 'packing',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveQuantityLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveWeightLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveCubageLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        }
      ],
      gridApi: null,
      left: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridDateTimeEditor
          },
          context: {
            componentParent: this
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocusedContainer(event)
          },
          onRowClicked: this.containerChangeHandler
        },
        gridApi: null
      },
      right: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowSelection: false,
          suppressRowClickSelection: false,
          rowMultiSelectWithClick: true,
          context: {
            componentParent: this
          }
        },
        gridApi: null
      },
      boxNoDialog: {
        visible: false
      },
      querySELclDialog: {
        visible: false
      },
      containerUsageColl: [], // 装箱信息
      selectedContainer: new Container().fillDefaultValue().getData(), // 选中的箱子
      job: new Job().fillDefaultValue().getData(),
      containers: [], // 箱子列表
      lclSlaves: [],
      slaveTotalDesc: { // 合计汇总
        slaveTotalQuantity: '',
        slaveTotalWeight: '',
        slaveTotalCubage: ''
      },
      usagesTotalDesc: { // 合计汇总
        txtNum: '',
        usageTotalQuantity: '',
        usageTotalWeight: '',
        usageTotalCubage: ''
      },
      totalLabel: { // 合计汇总label
        package: this.$t('SeaExport.TotalNumberOfPackages') + ':',
        weight: this.$t('SeaExport.TotalWeight') + ':',
        cubage: this.$t('SeaExport.TotalCubage') + ':'
      },
      operationTipsAarry: [], // 记录修改的 operationTips
      selectedSlave: {}, // 选中的小票
      updateLclSlaves: new Set() // 需要更新小票
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    // 显示拆分主票按钮
    showSplitButton() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    containerColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              classFunc: (params) => {
                return this.containerNbrStyleFunction(params.data)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
              this.onContainerChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.containerItemEditEndHandler(p) }
          }
        },
        { headerName: this.$t('SeaExport.DestinationDeliveryTime'), field: 'destinationDeliveryTime', colId: 'destinationDeliveryTime', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => {
            this.containerItemEditEndHandler(p)
            this.onContainerChange(p)
          }
        },
        { headerName: this.$t('SeaExport.DestinationReturnTime'), field: 'destinationReturnTime', colId: 'destinationReturnTime', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => {
            this.containerItemEditEndHandler(p)
            this.onContainerChange(p)
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        { headerName: this.$t('SeaExport.FreeStorageEndTime'), field: 'freeStorageEndTime', colId: 'freeStorageEndTime', width: 250,
          hide: true,
          valueFormatter: (params) => {
            if (params.data) {
              const freeStorageEndTime = params.data.freeStorageEndTime
              return freeStorageEndTime ? ColumnUtils.dateMinutesLabelFunc(freeStorageEndTime) : ''
            }
            return ''
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm',
              editable: false
            }
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data) {
              const freeStorageEndTime = params.data.freeStorageEndTime
              return freeStorageEndTime ? ColumnUtils.dateMinutesLabelFunc(freeStorageEndTime) : ''
            }
            return ''
          },
          onCellValueChanged: p => {
            this.containerItemEditEndHandler(p)
            this.onContainerChange(p)
          }
        },
        { headerName: this.$t('SeaExport.FreeContainerEndTime'), field: 'freeContainerEndTime', colId: 'freeContainerEndTime', width: 250,
          hide: true,
          valueFormatter: (params) => {
            if (params.data) {
              const freeContainerEndTime = params.data.freeContainerEndTime
              return freeContainerEndTime ? ColumnUtils.dateMinutesLabelFunc(freeContainerEndTime) : ''
            }
            return ''
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm',
              valueFormat: 'yyyy-MM-dd HH:mm',
              editable: false
            }
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data) {
              const freeContainerEndTime = params.data.freeContainerEndTime
              return freeContainerEndTime ? ColumnUtils.dateMinutesLabelFunc(freeContainerEndTime) : ''
            }
            return ''
          },
          onCellValueChanged: p => {
            this.containerItemEditEndHandler(p)
            this.onContainerChange(p)
          }
        }
      ]

      return columnDefs
    },
    usageColumnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'serialNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: this.isEdit ? 'el-input-number' : 'span',
            precision: 0,
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: 'MBL',
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          field: 'dischargingPortCode',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoName',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true }
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.Soc'),
          colId: 'soc',
          field: 'soc',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox'
          }
        }
      ]
      return columnDefs
    },
    config() {
      return this.context.config
    }
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }

      this.updateLclSlaves = new Set()

      const job = new SeaImportJob(row)
      // 复制，拆分 动作 无uuid
      if (row.uuid) {
        await Promise.all([
          job.getSeaEQ(),
          job.getLclSlaves(),
          job.getContainers()
        ])
        this.job = job
        if (job.seaEQ && job.seaEQ.length > 0 && (!job.containers || job.containers.length === 0)) {
          ContainerUtil.autoJustContainerUsages(job)
        }
        if (!job.containers) {
          job.containers = []
        }
        this.containers = job.containers
        this.lclSlaves = this.job.lclSlaves
      } else {
        row.seaEQ = []
        row.lclSlaves = []
        row.containers = []
      }

      this.pm.commitProperties()
    },
    // 保存数据提交
    getSubmitData() {
      // 海进cargo 保存未校验
      // this.pm.validateForm()

      // todo 重新组装数据 过滤 container.containerUsages isDirty=true 至后端保存
      return {
        containers: this.job.containers, // .filter(p => p.isDirty === true),
        delContainerUuids: this.job.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.job.delContainerUsageUuids, // 删除的装箱uuid
        lclSlaves: [... this.updateLclSlaves] // 参数 ContainerUpdateJobQCW =1 时装箱修改 小票件毛体
      }
    },

    // 箱子列编辑
    containerItemEditEndHandler(params) {
      params.data.isDirty = true // 用于校验数据是否修改标识
      if (params.field === 'sealNo') {
        params.data.isReSealed = true // 此属性赋值未用上
      }
    },
    // 列编辑修改事件 (usageItemEditEndHandler)
    onCellChange(params) {
      const usage = params.data
      if (!usage) {
        return
      }

      // 同步更新container的 usage
      for (const item of this.job.containers) {
        let bFlag = false
        for (const itemUsage of item.containerUsage) {
          if (itemUsage === usage) {
            item.isDirty = true
            bFlag = true
            break
          }
        }
        if (bFlag) {
          break
        }
      }
      usage.isDirty = true // 用于校验数据是否修改标识

      // 排序
      if (params.field === 'serialNo') {
        sortByMultiField(this.selectedContainer.containerUsage, ['serialNo'], false)
      }

      if (params.field === 'containerWeight') {
        // 箱重处理四舍五入 入库（控件只做了前端显示处理）
        if (params.data.containerWeight) {
          params.data.containerWeight = roundHalfUp(params.data.containerWeight, 2)
        } else {
          params.data.containerWeight = 0
        }
      }
      if (params.field === 'quantity' || params.field === 'weight' || params.field === 'cubage') {
        // 查找到对应的 lclSlave
        const lclJob = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
        if (lclJob) {
          ContainerNewUtil.SyncContainerQwcSynJob(lclJob, usage)

          // ContainerUpdateJobQCW 参数开启1 需要同步lclSlave 件毛体
          const expression = parseInt(this.config.get('ContainerUpdateJobQCW'))
          if (expression === 1) {
            this.updateLclSlaves.add(lclJob)
          }
        }
      }
      this.pm.refreshSalves()
    },
    onContainerChange(params) {
      const container = params.data
      if (!container) {
        return
      }
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'containerNo':
          container.syncToExport = true
          break
        case 'destinationDeliveryTime':
          container.syncToExport = true
          break
        case 'destinationReturnTime':
          container.syncToExport = true
          break
        case 'freeContainerEndTime':
          container.syncToExport = true
          break
        case 'freeStorageEndTime':
          container.syncToExport = true
          break
        default :
          break
      }
    },
    executeTask() {
      if (this.job && this.job.containers) {
        const containers = this.job.containers.filter(p => p.containerNo && p.syncToExport === true)
        if (this.job.trustFromJob && containers !== null && containers.length > 0) {
          syncContainersToExport(containers)
        }
      }
    },
    containerNbrStyleFunction(container) {
      if (container) {
        if (!ContainerNoHelper.checkContainerNo(container.containerNo)) {
          return 'data-red'
        }
      }
      return ''
    },
    slaveQuantityLabelFunc(data) {
      return this.pm.getItemLeft(data)
    },
    slaveWeightLabelFunc(data) {
      return NumberUtils.formatNumber(this.pm.getWeightLeft(data), 2)
    },
    slaveCubageLabelFunc(data) {
      return NumberUtils.formatNumber(this.pm.getCubageLeft(data), 3)
    },

    containerChangeHandler(event) {
      this.pm.containerChangeHandler(event)
    },
    // 小票行选中
    onRowClicked(event) {
      this.selectedSlave = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedSlave = node.data
          }
        })
      }
    },
    onCellFocusedContainer(event) {
      if (this.left.gridOptions.api && event.column) {
        this.left.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainer = node.data
          }
        })
      }
    },
    getPrintData() {
      if (this.lclSlaves == null) return
      const job = this.job
      if (job && job.masterFlag) {
        const containers = this.gridApi.getSelectedRows()
        const params = {}
        if (containers.length === 0) {
          this.$message.warning('未勾选装箱信息')
          return null
        }
        if (containers.length === 1) {
          const container = containers[0]
          params.CONTAINER_UUID = container.uuid
          params.jobuuid = job ? job.uuid : ''
          params.job = job
          params.category = 'LCL'
          params.ctx = new SeaImportJob(this.job)
        } else {
          const uids = []
          for (const c of containers) {
            uids.push(c.uuid)
          }
          params.CONTAINER_UUID = uids
          params.jobuuid = job ? job.uuid : ''
          params.job = job
          params.category = 'CONTAINER_LIST'
          params.ctx = new SeaImportJob(this.job)
        }
        return params
      }
      return null
    }
  }
}
</script>

<style lang='scss'>
  .data-red {
    color: #FF0000;
  }
  .data-blue{
    color: #0000ff;
  }
  #tabLclContainer {
    .data-red {
      input.el-input__inner {
        color: #FF0000;
      }
    }
    .data-blue {
      input.el-input__inner {
        color: #0000ff;
      }
    }
  }
</style>
